__turbopack_context__.v({
  "available": "store-availability-component-module-scss-module__gIIYQa__available",
  "store-availability": "store-availability-component-module-scss-module__gIIYQa__store-availability",
  "store-availability--has-primary-button": "store-availability-component-module-scss-module__gIIYQa__store-availability--has-primary-button",
  "unavailable": "store-availability-component-module-scss-module__gIIYQa__unavailable",
});
